import gsap from 'gsap';

const TitleIn = (element) => {
  const lines = [...element.querySelectorAll('.title__char')];
  const tl = gsap.timeline();
  tl.to(lines, {
    yPercent: 0,
    duration: 1.2,
    ease: 'expo.out',
    stagger: 0.05,
  });
  return tl;
};

export default TitleIn;
